import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UiManagerService} from "../../services/ui-manager.service";

export interface TimelineGroup {
  id: string
  title: string
  elements: TimelineElement[]
}

export enum TimelineElementStatus {
  NONE,
  CHECKED,
  ERROR
}

export interface TimelineElement {
  id: string
  status: TimelineElementStatus
  title: string
  description: string
  timestamp?: Date
}

export interface TimelineUpdate {
  groupId: string
  elementId: string
  isExecuted: boolean
}

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

  @Input()
  groups: TimelineGroup[];

  @Input()
  canEdit: boolean;

  @Output()
  onUpdate: EventEmitter<TimelineUpdate>

  constructor(
    private uiManagerService: UiManagerService
  ) {
    this.onUpdate = new EventEmitter<TimelineUpdate>();
  }

  onElementUpdate(event: TimelineUpdate) {
    if (event.isExecuted) {
      this.done(event.groupId, event.elementId);
    } else {
      this.skip(event.groupId, event.elementId);
    }
  }

  done(groupId: string, elementId: string) {
    this.uiManagerService.showConfirmDialog(
      'Close step',
      'Do you want to close this step with status <strong>done</strong>?',
      async () => {
        this.onUpdate.emit({ groupId, elementId, isExecuted: true });
        this.setElementAsCompleted(groupId, elementId, TimelineElementStatus.CHECKED);
      }
    );
  }

  skip(groupId: string, elementId: string) {
    this.uiManagerService.showConfirmDialog(
      'Close step',
      'Do you want to close this step with status <strong>skipped</strong>?',
      async () => {
        this.onUpdate.emit({ groupId, elementId, isExecuted: false });
        this.setElementAsCompleted(groupId, elementId, TimelineElementStatus.ERROR);
      }
    );
  }

  setElementAsCompleted(groupId: string, elementId: string, status: TimelineElementStatus) {
    const elem = this.groups.find(group => group.id == groupId)?.elements.find(element => element.id == elementId);
    if (elem) {
      elem.status = status;
    }
  }

  hasCompletedChecks() {
    return this.groups.every(group => group.elements.every(element => element.status != TimelineElementStatus.NONE));
  }

  ngOnInit(): void { }

}
